var _path, _path2, _path3, _path4, _path5, _g, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgEmptySearch(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 131,
    height: 138,
    viewBox: "0 0 131 138",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M72.5229 113.042C101.408 113.042 124.826 89.6246 124.826 60.6361C124.826 31.6475 101.305 8.22974 72.5229 8.22974C43.6375 8.22974 20.2197 31.6475 20.2197 60.6361C20.2197 89.6246 43.6375 113.042 72.5229 113.042Z",
    fill: "#EAEEF9"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M121.422 26.283C123.758 26.283 125.651 24.3893 125.651 22.0534C125.651 19.7174 123.758 17.8237 121.422 17.8237C119.086 17.8237 117.192 19.7174 117.192 22.0534C117.192 24.3893 119.086 26.283 121.422 26.283Z",
    fill: "#EAEEF9"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M127.611 9.77707C129.207 9.77707 130.5 8.48383 130.5 6.88854C130.5 5.29324 129.207 4 127.611 4C126.016 4 124.723 5.29324 124.723 6.88854C124.723 8.48383 126.016 9.77707 127.611 9.77707Z",
    fill: "#EAEEF9"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M23.0051 26.1797C24.6004 26.1797 25.8937 24.8864 25.8937 23.2911C25.8937 21.6958 24.6004 20.4026 23.0051 20.4026C21.4098 20.4026 20.1166 21.6958 20.1166 23.2911C20.1166 24.8864 21.4098 26.1797 23.0051 26.1797Z",
    fill: "#EAEEF9"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M5.36443 81.8875C8.32712 81.8875 10.7289 79.4858 10.7289 76.5231C10.7289 73.5604 8.32712 71.1587 5.36443 71.1587C2.40174 71.1587 0 73.5604 0 76.5231C0 79.4858 2.40174 81.8875 5.36443 81.8875Z",
    fill: "#EAEEF9"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_8764_38637)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M108.114 34.4326L108.939 100.869C108.939 103.139 107.082 104.892 104.813 104.892H40.027C37.7574 104.892 35.9005 103.035 35.9005 100.869V15.4508C35.9005 13.1812 37.7574 11.4275 40.027 11.4275H86.9657L108.114 34.4326Z",
    fill: "url(#paint0_linear_8764_38637)"
  }))), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M67.4679 91.5845H65.0952C64.5794 91.5845 64.1667 91.0687 64.1667 90.4497C64.1667 89.8308 64.5794 89.3149 65.0952 89.3149H67.4679C67.9837 89.3149 68.3964 89.8308 68.3964 90.4497C68.3964 91.1719 67.9837 91.5845 67.4679 91.5845Z",
    fill: "#CED7E2"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M60.2466 91.5845H46.4228C45.907 91.5845 45.4944 91.0687 45.4944 90.4497C45.4944 89.8308 45.907 89.3149 46.4228 89.3149H60.2466C60.7624 89.3149 61.175 89.8308 61.175 90.4497C61.175 91.1719 60.7624 91.5845 60.2466 91.5845Z",
    fill: "#D5DDEA"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M77.8873 25.3546H46.8355C46.1134 25.3546 45.4944 24.7356 45.4944 24.0135C45.4944 23.2913 46.1134 22.6724 46.8355 22.6724H77.8873C78.6094 22.6724 79.2284 23.2913 79.2284 24.0135C79.2284 24.7356 78.6094 25.3546 77.8873 25.3546Z",
    fill: "#D5DDEA"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M58.8023 32.7823H46.8355C46.1134 32.7823 45.4944 32.1633 45.4944 31.4412C45.4944 30.7191 46.1134 30.1001 46.8355 30.1001H58.6991C59.4213 30.1001 60.0402 30.7191 60.0402 31.4412C60.0402 32.1633 59.4213 32.7823 58.8023 32.7823Z",
    fill: "#D5DDEA"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M86.9657 11.4277V29.7906C86.9657 32.3696 89.2353 34.4329 91.8143 34.4329H108.114",
    fill: "#D5DDEA"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M113.066 106.44C112.034 106.44 111.002 106.027 110.177 105.099L92.949 87.8707L92.33 88.2834C86.7592 92.4099 80.26 94.5763 73.6577 94.5763C65.7142 94.5763 57.7707 91.3782 51.8905 85.8075C45.7007 79.9273 42.2964 71.9838 42.2964 63.3182C42.2964 46.0901 56.3264 32.0601 73.5545 32.0601C85.315 32.0601 95.6312 38.2498 101.202 48.7723C106.67 59.1917 105.947 71.3648 99.2418 81.1652L98.8292 81.7842L116.16 99.1154C117.914 100.869 117.502 102.623 117.192 103.551C116.367 105.202 114.716 106.44 113.066 106.44ZM73.5545 40.6225C60.9687 40.6225 50.8588 50.8356 50.8588 63.3182C50.8588 77.5545 62.5161 86.117 73.864 86.117C80.7758 86.117 87.0687 83.0221 91.5047 77.4514C96.9723 70.6427 97.9007 61.4612 94.0837 53.5178C90.1636 45.5743 82.3233 40.6225 73.5545 40.6225Z",
    fill: "#989FB0"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M63.7541 67.0321C65.0952 67.0321 66.23 65.8973 66.23 64.5562C66.23 63.2151 65.0952 62.0803 63.7541 62.0803C62.413 62.0803 61.2782 63.2151 61.2782 64.5562C61.2782 65.8973 62.413 67.0321 63.7541 67.0321Z",
    fill: "#989FB0"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M82.7359 67.0321C84.077 67.0321 85.2118 65.8973 85.2118 64.5562C85.2118 63.2151 84.077 62.0803 82.7359 62.0803C81.3948 62.0803 80.26 63.2151 80.26 64.5562C80.26 66.0005 81.3948 67.0321 82.7359 67.0321Z",
    fill: "#989FB0"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M63.6573 56.3649L58.2109 59.3057L58.9461 60.6672L64.3925 57.7265L63.6573 56.3649Z",
    fill: "#989FB0"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M82.3992 56.326L81.6642 57.6877L87.1111 60.6279L87.8462 59.2661L82.3992 56.326Z",
    fill: "#989FB0"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M73.245 72.8091C74.8403 72.8091 76.1335 71.8392 76.1335 70.6427C76.1335 69.4462 74.8403 68.4763 73.245 68.4763C71.6497 68.4763 70.3564 69.4462 70.3564 70.6427C70.3564 71.8392 71.6497 72.8091 73.245 72.8091Z",
    fill: "#989FB0"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_8764_38637",
    x: 13.9005,
    y: 0.42749,
    width: 117.039,
    height: 137.465,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 11
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 11
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.397708 0 0 0 0 0.47749 0 0 0 0 0.575 0 0 0 0.27 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_8764_38637"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_8764_38637",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_8764_38637",
    x1: 72.3961,
    y1: 9.26556,
    x2: 72.3961,
    y2: 105.9,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FDFEFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9964,
    stopColor: "#ECF0F5"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmptySearch);
export default __webpack_public_path__ + "static/media/EmptySearch.e35841015c0d6adec54dc8415c583cf7.svg";
export { ForwardRef as ReactComponent };